



































import Vue from 'vue';
import SubstepNumber from '@/components/common/SubstepNumber.vue';
import GlowingBulb from './subcomponents/GlowingBulb.vue';
import CloseWindowButton from '@/components/common/CloseWindowButton.vue';
import GlowingBulbVariant from '@/enums/GlowingBulbVariant';
import SwitchWithHand from './subcomponents/SwitchWithHand.vue';
import ActionButton from '@/components/common/ActionButton.vue';
import router from '@/router';

export default Vue.extend({
  name: 'PutIntoAPPairingModeInstructionsPage3Clicks',
  components: {
    SubstepNumber,
    GlowingBulb,
    SwitchWithHand,
    ActionButton,
    CloseWindowButton
  },
  data() {
    return {
      glowingBulbVariant: GlowingBulbVariant.OnOff,
    };
  },
  computed: {
    faqLinkLocation(): string {
      return 'https://taolight.helpshift.com/a/wiz/?l=en&s=getting-started&f=setting-lights-to-pairing-mode';
    },
  },
  methods: {
    handAnimationFinished() {
      this.glowingBulbVariant = GlowingBulbVariant.Pairing;
    },
    nextClicked() {
      router.replace('Instructions_waitap');
    },
  },
});



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/shortcutInstructions/PutIntoAPPairingModeInstructionsPage3Clicks.vue